module.exports = __webpack_public_path__ + "img/开门按钮 (6).8d3b05bf.jpg";